// Personeli adlandıran TEK kural (GL #12). Ad soyad davette ve aktivasyonda isteğe bağlıdır
// (§13.5/§13.6 `firstName?`/`lastName?`), yani adsız personel olağan bir durumdur. Ad boşsa
// iletişim (`emailOrPhone`) satırı adlandırır: ⋮ etiketi, `title`, onay ve hata metinleri hep
// buradan okur. Saf TS — `core.ts`'ten dışa aktarılır (mobil güvenli).

export interface PersonLabelInput {
  firstName?: string | null;
  lastName?: string | null;
  emailOrPhone?: string | null;
}

/**
 * Kırpılmış "Ad Soyad"; boşsa `emailOrPhone`; o da yoksa `''`. Yalnız adı isteyen çağıran
 * (iletişim sütunu olan tablolar) `emailOrPhone`'u vermez.
 */
export function personLabel(p: PersonLabelInput): string {
  const name = `${p.firstName ?? ''} ${p.lastName ?? ''}`.trim();
  return name || p.emailOrPhone || '';
}
